<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="1100"
    scrollable
    :fullscreen="isMobile()"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-on="on" v-bind="attrs" color="teal" title="Perfil" icon
        ><v-icon>mdi-clipboard-account-outline</v-icon></v-btn
      >
    </template>
    <v-card :loading="loading">      
      <v-card-title :class="'font-weight-bold ' + classCardTitle()"
        >{{ cliente.nome }} - {{ cliente.matricula }}
      </v-card-title>
      <v-card-subtitle :class="classCardTitle()"
        >Perfil do cliente</v-card-subtitle
      >
      <v-card-text v-if="!loading" :class="classCardText()">
        <v-tabs
          grow
          show-arrows=""
          active-class="font-weight-bold green lighten-5"
          v-model="tab"
          slider-size="3"
          :background-color="isMobile() ? 'green lighten-5' : ''"
        >
          <v-tab>Produtos com saldo</v-tab>
          <v-tab>Posição atual</v-tab>
          <v-tab>Resumo de compras</v-tab>
          <v-tab>Pagamentos</v-tab>
          <v-tab>Cheques</v-tab>
          <v-tab>Outros Dados</v-tab>
          <v-tab>Restrições</v-tab>
        </v-tabs>        
        <v-tabs-items v-model="tab" :class="isMobile() ? 'mr-4 ml-4' : ''">
          <v-tab-item>
            <card-produtos-em-aberto class="mt-4" :cliente="perfil" />
          </v-tab-item>
          <v-tab-item>
            <card-limite-credito class="mt-4" :perfil="perfil" />
            <card-posicao-atual class="mt-3" :perfil="perfil" />
          </v-tab-item>
          <v-tab-item>
            <card-resumo-compras :perfil="perfil" />
          </v-tab-item>
          <v-tab-item>
            <card-pagamentos class="mt-4" :perfil="perfil" />
          </v-tab-item>
          <v-tab-item>
            <card-cheques class="mt-4" :perfil="perfil" />
          </v-tab-item>
          <v-tab-item>
            <card-outros-dados :perfil="perfil" :cliente="dadosGeraisCliente" />
          </v-tab-item>
          <v-tab-item>
            <card-mensagens-cliente
              class="mt-4"
              :cliente="dadosGeraisCliente"
            />
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
      <v-progress-linear indeterminate v-else-if="isMobile()"></v-progress-linear>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          @click="dialog = false"
          rounded
          :text="!isMobile()"
          color="secondary"
          :block="isMobile()"
          >Fechar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from "moment";
import { mapActions, mapMutations, mapState } from "vuex";
import CardLimiteCredito from "./CardLimiteCredito.vue";
import CardPagamentos from "./CardPagamentos.vue";
import CardOutrosDados from "./CardOutrosDados.vue";
import CardCheques from "./CardCheques.vue";
import CardResumoCompras from "./CardResumoCompras.vue";
import CardPosicaoAtual from "./titulos-em-aberto/CardPosicaoAtual.vue";
import CardProdutosEmAberto from "../clientes/produtos-em-aberto/CardProdutosEmAberto.vue";
import CardMensagensCliente from "../clientes/CardMensagensCliente.vue";

export default {
  components: {
    CardLimiteCredito,
    CardPagamentos,
    CardOutrosDados,
    CardCheques,
    CardResumoCompras,
    CardPosicaoAtual,
    CardProdutosEmAberto,
    CardMensagensCliente,
  },
  watch: {
    dialog: async function (open) {
      if (open) {
        this.loading = true;

        this.dadosGeraisCliente = this.cliente;
        await this.carregarPerfilCliente();
        if (this.cliente.carregardadoscliente) {
          this.setClientes(
            await this.getClientes({ pesquisa: this.cliente.matricula })
          );
          if (this.clientes.length > 0) {
            this.dadosGeraisCliente = this.clientes[0];
          }
        }
        this.loading = false;
      }
    },
  },
  props: {
    cliente: Object,
  },
  computed: mapState("clientes", ["clientes"]),
  data: () => ({
    dialog: false,
    dadosGeraisCliente: null,
    perfil: null,
    loading: true,
    tab: 0,
    periodoSelecionado: 1,
    periodos: [
      { text: "1 Ano", value: 1 },
      { text: "2 Anos", value: 2 },
      { text: "3 Anos", value: 3 },
      { text: "4 Anos", value: 4 },
      { text: "5 Anos", value: 5 },
    ],
  }),
  methods: {
    ...mapMutations("clientes", ["setClientes"]),
    ...mapActions("clientes", ["getPerfil", "getClientes"]),
    async carregarPerfilCliente() {
      const perfis = await this.getPerfil({
        matricula: this.cliente.matricula,
        periodo: 5,
      });
      this.perfil = null;
      if (perfis.length > 0) {
        this.perfil = perfis[0];
      }
    },
    formatarData(value) {
      return moment(value).format("DD/MM/YYYY");
    },
    isMobile() {
      return this.$mq == "sm";
    },
    classCardText() {
      return this.isMobile() ? "ml-0 mr-0 pr-0 pl-0" : "";
    },
    classCardTitle() {
      return this.isMobile() ? "green darken-4 white--text" : "";
    },
  },
};
</script>

<style>
</style>